// SwipeCard constants - shared across platforms

export const CARD_MAX_WIDTH = 400;

export const BADGE_SPACING = 12;
export const BADGE_BORDER_RADIUS = 9999;
export const BADGE_ICON_SIZE = 16;

export const PHOTO_INDICATOR_ACTIVE_SIZE = 8;
export const PHOTO_INDICATOR_INACTIVE_SIZE = 6;
export const PHOTO_INDICATOR_MARGIN = 3;

export const INFO_BUTTON_BOTTOM = 160;
export const INFO_BUTTON_HORIZONTAL_PADDING = 12;
export const INFO_BUTTON_VERTICAL_PADDING = 10;

export const PROFILE_NAME_FONT_SIZE = 24;
export const PROFILE_TAGLINE_FONT_SIZE = 16;
export const PROFILE_DETAIL_FONT_SIZE = 16;
export const PROFILE_PRICE_FONT_SIZE = 26;
export const INFO_BUTTON_FONT_SIZE = 16;

export const BADGE_CHECK_SIZE = 26;
export const CALENDAR_ICON_SIZE = 20;
export const ONLINE_STATUS_FONT_SIZE = 15;

// Card width constant (for mobile wrapper)
export const CARD_WIDTH = 350;
